export default __webpack_public_path__ + "static/bed-bath-beyond-8-b-0822826ea38dc44f4e5ebc23938940c1.webp";